"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MenuMap;
var _react = _interopRequireWildcard(require("react"));
var _Menu = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Menu"));
var _CornerstoneIcon = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneIcon"));
var _reactRouterDom = require("react-router-dom");
var _PopupSubMenu = _interopRequireWildcard(require("cornerstone_ui_core/lib/containers/BaseLayout/Menu/MenuMap/PopupSubMenu"));
require("cornerstone_ui_core/lib/containers/BaseLayout/Menu/MenuMap/menu-map.scss");
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// import HoverSubMenu from "./HoverSubMenu";

const {
  SubMenu
} = _Menu.default;
function MenuMap(_ref) {
  let {
    menus,
    dispatch,
    ...rest
  } = _ref;
  return menus.map((menu, i) => menu.menus && menu.menus.length ? SubMenuComponent({
    title: MenuItemBody({
      menu
    }),
    ...rest,
    menu,
    // type: "submenu",
    type: menu.mode,
    // onMouseEnter: ({ domEvent }) => domEvent && domEvent.stopPropagation(),
    triggerSubMenuAction: "click",
    id: menu.key,
    children: MenuMap({
      menus: menu.menus,
      ...rest
    })
  }) : /*#__PURE__*/_react.default.createElement(_Menu.default.Item, _extends({
    key: menu.key
  }, rest), MenuItemBody({
    menu
  })));
}
function SubMenuComponent(_ref2) {
  let {
    type,
    ...rest
  } = _ref2;
  switch (type) {
    case "popup":
      return /*#__PURE__*/_react.default.createElement(_PopupSubMenu.default, _extends({
        key: rest.id
      }, rest));
    default:
      // return <HoverSubMenu key={rest.id} {...{ ...rest }} />;
      return /*#__PURE__*/_react.default.createElement(SubMenu, _extends({}, rest, {
        key: rest.id
      }));
  }
}
function MenuItemBody(_ref3) {
  let {
    menu,
    ...rest
  } = _ref3;
  let {
    icon
  } = menu;
  if (menu.path || menu.command) return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, _extends({
    to: menu.path,
    className: "menu-item-wrapper"
  }, rest, {
    onClick: () => {
      if (menu.command) menu.command(menu);
      if (menu.redirect) window.location = menu.redirect;
      _PopupSubMenu.emitter.emit("PopupSubMenu:open");
    }
  }), (0, _lodash.isString)(icon) && /*#__PURE__*/_react.default.createElement(_CornerstoneIcon.default, {
    type: menu.icon,
    rotate: menu.rotate
  }), !(0, _lodash.isString)(icon) && /*#__PURE__*/_react.default.createElement(_CornerstoneIcon.default, {
    component: icon
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "menu-item-title"
  }, menu.title), menu.iconTitle && /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-title"
  }, menu.iconTitle));
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", _extends({
    onClick: menu.onClick,
    className: "menu-item-wrapper"
  }, rest), (0, _lodash.isString)(icon) && /*#__PURE__*/_react.default.createElement(_CornerstoneIcon.default, {
    type: menu.icon,
    rotate: menu.rotate
  }), !(0, _lodash.isString)(icon) && /*#__PURE__*/_react.default.createElement(_CornerstoneIcon.default, {
    component: icon
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "menu-item-title",
    title: menu.title
  }, menu.title), menu.iconTitle && /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-title"
  }, menu.iconTitle)));
}